import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import React, { useContext } from 'react';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import GlobalContext from './context/GlobalContext';
import './index.css';
import { TableDataProvider } from './presentation/pages/admin/constructions/ConstructionsDetails/budgets/NewBudget/EditBudgetV2/context/EditingTableDataContext';
import HomeAdmin from './presentation/pages/admin/home/HomeAdmin';
import Login from './presentation/pages/others/login/Login';
import NotFound from './presentation/pages/others/notFound/NotFound';
import ResetAccount from './presentation/pages/others/resetAccount/ResetAccount';
import Verification from './presentation/pages/others/verification/Verification';
import ResendEmail from './presentation/pages/others/resendEmail/ResendEmail';
import { LoginSuperAdmin } from './presentation/pages/superAdmin/Login/LoginSuperAdmin';
import Theme from './presentation/styles/themes';
import { AdminRoutes, ClientsRoutes, SuperAdminRoutes } from './routes';

import 'react-toastify/dist/ReactToastify.css';
import TourProvider from './providers/TourProvider';

function App() {
  const { companyData, userData } = useContext(GlobalContext);

  const user = userData || JSON.parse(localStorage.getItem('user'));

  const isSuperAdmin = window.location.href.includes('.localhost');
  const isProduction = window.location.href.includes('.sioon');

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={Theme(companyData)}>
        <ToastContainer
          position="top-center"
          style={{
            width: '100%',
          }}
        />

        <Router>
          <TourProvider>
            <TableDataProvider>
              <Routes>
                <Route path="/" element={<Login />} />
                {!isSuperAdmin && !isProduction && (
                  <Route path="/admin" element={<LoginSuperAdmin />} />
                )}
                <Route path="/verification" element={<Verification />} />
                <Route path="/login" element={<Login />} />
                <Route path="/reset_account" element={<ResetAccount />} />
                <Route path="/homeAdmin" element={<HomeAdmin />} />
                <Route path="/resend_email" element={<ResendEmail />} />
                {user && user.user_type === 'super_admin' && (
                  <Route path="*" element={<SuperAdminRoutes />} />
                )}
                {user && user.user_type === 'admin' && (
                  <Route path="*" element={<AdminRoutes />} />
                )}
                {user && user.user_type === 'client' && (
                  <Route path="*" element={<ClientsRoutes />} />
                )}
                <Route path="*" element={<Navigate to="/login" />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </TableDataProvider>
          </TourProvider>
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
